export default __webpack_public_path__ + "static/media/picture2.94332380.png";